module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "pa_com_dialog",
    class: _vm.size,
    attrs: {
      "title": _vm.title ? _vm.title : '温馨提示',
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": function($event) {
        return _vm.submitTap('0')
      }
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.conText))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "8px",
      "color": "grey",
      "margin-top": "30px"
    }
  }, [_vm._v(_vm._s(_vm.descText))]), _vm._v(" "), (_vm.type != '1') ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.submitTap('1')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "FF7"
    },
    on: {
      "click": function($event) {
        return _vm.submitTap('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.successText ? _vm.successText : '确 认'))])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d5f8d30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/alertPop.vue
// module id = 3507
// module chunks = 103